import { SVGPureIcon } from '@/ui';
import aiSoHomeStore from '@/pages/search-home/store';

const BackBtn = () => {
  if (!aiSoHomeStore.showCustomInputPage) return null;
  return (
    <div
      className={['size-32px flex items-center justify-center cursor-pointer mr-8px rounded-8px hover:bg-black hover:bg-opacity-3']}
      onClick={() => {
        aiSoHomeStore.closeCustomInputPage();
      }}
    >
      <SVGPureIcon name="header_back_arrow" className="size-24px" />
    </div>
  );
};

export default BackBtn;
